
export const summaryPayload = {
    "originRegion": "NA",
    "carrierCodeList": [],
    "tariffServiceCodeList": [],
    "originCityStateList": [],
    "deliveryActualArrivalDatetimeFinalDestTZ": null,
}
